module.exports = __webpack_public_path__ + "static/media/union.427c3f6b.png";